import * as math from 'mathjs'

export class EcuationFragment {

    ecuation: string
    constructor(_ecuation: string){
        this.ecuation = _ecuation
    }

    processEcuation(_throw = true): { variables: RegExpMatchArray | any [], depends_on?: string[] } | Error | {ecuationError: string} {

        let variables = this.extractEcuationVariables()
        let mathEcuation: { mathEcuation: string, ctx: {} } = this.createMathEcuation()
        let ecuationTestResult: number | Error = this.testEcuation(mathEcuation.mathEcuation, mathEcuation.ctx, _throw)

        if (ecuationTestResult instanceof Error && _throw) {
            throw ecuationTestResult
        } else if(ecuationTestResult instanceof Error && !_throw) {
            return {ecuationError:'Existen errores en la ecuación'}
        }

        if(_throw) {
            return { variables }
        } else {
            return null
        }

    }

    extractEcuationVariables() {

        if (!this.ecuation) return
        let rx = /(?<={)([^\d]?[\$]?[\w]+)(?=})/g
        let rawExtEcuationVariables = this.ecuation.trim().match(rx)
        if (!rawExtEcuationVariables || !rawExtEcuationVariables.length) return []
        return rawExtEcuationVariables
    }

    createMathEcuation(randomVariableValues: boolean = true) {

        let variables = this.extractEcuationVariables()

        let ctx: {[key:string]: any} = {}

        if (!variables.length) return { mathEcuation: this.ecuation, ctx }

        let mathEcuation = this.ecuation
        variables.map(variable => {
            ctx[variable] = randomVariableValues ? (Math.random() * 10).toFixed(2) : undefined
            let regEx = new RegExp(`{${variable}}`)
            mathEcuation = mathEcuation.replace(regEx, variable)
        })

        return { mathEcuation, ctx }
    }

    testEcuation(ecuation: string, ctx: {}, _throw = true) {
        try {
            let result = math.evaluate(ecuation, ctx)
            if (isNaN(result) && !result.hasOwnProperty('re')) return new Error('Existen errores en la ecuación definida. El resultado obtenido no es un número')

        } catch (err) {
            console.log(err)
            return new Error('Existen errores en la ecuación definida')
        }
    }

}